<template>
    <div v-if="cards && cards.length>=0" class="w-full flex flex-column">
        <div v-if="cards.length > 0" class="w-full flex flex-column">
            <div class="w-full flex flex-row flex-wrap gap-2 mb-2 text-xs">
                <Dropdown v-model="cardFilterCurrency" :options="cardCurrencies" optionLabel="name" optionValue="value" placeholder="Валюта" class="flex border-round-md" />
                <Dropdown v-model="cardFilterType" :options="cardTypes" optionLabel="name" optionValue="value" placeholder="Тип" class="flex border-round-md" />
                <Dropdown v-model="cardActive" :options="cardActiveList" optionLabel="name" optionValue="value" placeholder="Активность" class="flex border-round-md" />
                <Button @click="clearFilter" icon="pi pi-times" class="flex border-round-md surface-100 text-400 border-0"/>
            </div>
            <div class="w-full flex flex-wrap flex-row gap-3 text-sm text-600 mb-2">
                <span class="flex">Всего: {{ totalCount }}</span>
                <span class="flex">Отфильтровано: {{ filteredCount }}</span>
            </div>
        </div>
        <div v-else class="w-full">
            <span class="flex">У вас еще нет карт</span>
        </div>
        
        <div v-if="cards && cardsFiltered && cardsFiltered.length>0" class="w-full flex flex-wrap flex-column
            gap-2 xl:gap-3 lg:gap-3 md:gap-2 
             xl:flex-row lg:flex-row md:flex-row">
            <div v-for="card in cardsFiltered" class="w-full flex flex-column flex-1 surface-50 
                border-round-2xl 
                p-3 xl:p-4 lg:p-4 md:p-4
                text-left relative" style="min-width: 40%">
                <Card :card="card" :editing="editing"/>
            </div>
        </div>
    </div>
    <div v-else class="w-full">
        <Skeleton  height="3rem" class="border-round-lg"/> 
    </div>  
</template>

<script>
import Card from '@/components/merchant/CardWidget.vue'
import Helper from '@/assets/js/Helper'
import { BankList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList } from '@/assets/js/classes/Currency.js'

export default {
    props: ['cards', 'editing'],
    data() {
        return {
            totalCount: 0,
            filteredCount: 0,
            cardsFiltered: [],
            cardCurrencies: [],
            cardFilterCurrency: null,
            cardTypes: [],
            cardFilterType: null,
            cardFilter: {
                currency_code: null,
                type: null,
                active: null
            },
            cardActiveList: [
                {
                    name: 'Все',
                    value: null
                },
                {
                    name: 'Активные',
                    value: true
                },
                {
                    name: 'Неактивные',
                    value: false
                }
            ],
            cardActive: null,
            banks: [],
            currencies: []
        }
    },
    components: {
        Card
    },
    methods: {
        get_card_type(type){
            return this.helper.get_card_type(type)
        },
        toFilterCards(){
            const list = this.cards.filter(card => {
                if(this.cardFilter.currency_code && card.currency_code !== this.cardFilter.currency_code) return false
                if(this.cardFilter.type && card.type !== this.cardFilter.type) return false
                if(this.cardFilter.active !== null && card.active !== this.cardFilter.active) return false
                return true
            })
            this.filteredCount = list.length
            return list
        },
        clearFilter(){
            this.cardFilterCurrency = null
            this.cardFilterType = null
            this.cardActive = null
            this.cardsFiltered = this.cards
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : code
        },
        async GetBanks(){
            this.banks = await BankList.GetList(this.$store).then(r=>r)
        },
        async GetCurrencies(){
            this.currencies = await CurrencyList.GetList(this.$store).then(r=>r)
        },
    },
    watch: {
        cards(val){
            if(!val) return
            // скопировать в cardsFiltered
            this.cardsFiltered = val
            this.totalCount = val.length
            this.filteredCount = val.length

            // получим список валют
            this.cardCurrencies = []
            this.cardCurrencies.push({
                name: 'Все',
                value: null
            })
            const currencies = this.cards.map(card => card.currency_code)
            const filteredCurrencies = [...new Set(currencies)].map(currency_code => {
                if(!currency_code) return
                return {
                    name: currency_code,
                    value: currency_code
                }
            })
            this.cardCurrencies = this.cardCurrencies.concat(filteredCurrencies)

            // получим типы карт
            this.cardTypes = []
            this.cardTypes.push({
                name: 'Все',
                value: null
            })
            const types = this.cards.map(card => card.type)
            const filteredTypes = [...new Set(types)].map(type => {
                if(!type) return
                return {
                    name: this.get_card_type(type),
                    value: type
                }
            })
            this.cardTypes = this.cardTypes.concat(filteredTypes)
        },
        cardFilterCurrency(val) {
            this.cardFilter.currency_code = val
            this.cardsFiltered = this.toFilterCards()
        },
        cardFilterType(val) {
            this.cardFilter.type = val
            this.cardsFiltered = this.toFilterCards()
        },
        cardActive(val) {
            this.cardFilter.active = val
            this.cardsFiltered = this.toFilterCards()
        }
    },
    async beforeCreate(){
        this.helper = new Helper()
    },
    async mounted(){
        this.GetBanks()
        this.GetCurrencies()
    }
}
</script>